import React, { PureComponent } from 'react';
import { Link, scrollSpy } from 'react-scroll';
import bowser from 'bowser';
import styles from './Nav.css';
import { gcpURL } from '../../lib/utils';

const icon17 = `${gcpURL}/static/logo_with_name.svg`;

// TODO: add links for mobile app
const IOS_LINK = 'https://itunes.apple.com/us/app/id988259048?mt=8';
const ANDROID_LINK = 'https://play.google.com/store/apps/details?id=com.machipopo.media17&referrer=af_tranid%3DdSHacqOVljXiqzKjOEGakg%26pid%3DOffcial%20Site';

const A = ({ text, className, ...props }) => (
  <a
    className={`${styles.navItem} ${className}`}
    target="_blank"
    rel="noopener noreferrer"
    data-ga-on="click"
    data-ga-event-category="Header"
    data-ga-event-action={text}
    {...props}
  >
    {text}
  </a>
);

const NavItem = ({ text, className, ...props }) => (
  <Link
    {...props}
    className={`${styles.navItem} ${className}`}
    smooth
    spy
    isDynamic
    offset={-60}
    duration={500}
    to={text}
    activeClass={styles.isActive}
    rel="noopener noreferrer"
    data-ga-on="click"
    data-ga-event-category="Header"
    data-ga-event-action={text}
  >
    {text}
  </Link>
);

class Nav extends PureComponent {
  componentDidMount() {
    scrollSpy.update();
  }

  render() {
    let appLink = 'http://17.media/';
    if (bowser.ios) {
      appLink = IOS_LINK;
    } else if (bowser.android) {
      appLink = ANDROID_LINK;
    }

    return (
      <nav className={styles.nav}>
        <div className={styles.container}>
          <a href="http://17.media/" className={styles.logo}>
            <img src={icon17} alt="17 Media" />
          </a>

          <div className={styles.navList}>
            <NavItem text="關於金羽" className="hideMobile" />
            <NavItem text="星光雲集" className="hideMobile" />
            <NavItem text="獎項列表" className="hideMobile" />
            <A
              text="FB 分享"
              onClick={() => {
                FB.ui({
                  method: 'share',
                  href: location.href,
                });
              }}
            />
            <div className={styles.divisor} />
            <A text="免費線上看" className={styles.hasOutline} href={appLink} />
          </div>
        </div>
      </nav>
    );
  }
}

export default Nav;



// WEBPACK FOOTER //
// ./src/components/Nav/index.js